import { gql, useEnhancedLazyQuery } from "@uplift-ltd/apollo";
import { useReCaptcha } from "next-recaptcha-v3";
import { RECAPTCHA_SITE_KEY } from "constants/site";
import { RecaptchaVerifyDocument } from "hooks/__generated__/useReCaptchaVerify";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const RECAPTCHA_VERIFY_QUERY = gql`
  query recaptchaVerify($token: String!) {
    recaptchaVerify(token: $token)
  }
`;

export const useReCaptchaVerify = () => {
  const [verify] = useEnhancedLazyQuery(RecaptchaVerifyDocument);
  const { executeRecaptcha } = useReCaptcha();

  return async (action: string) => {
    if (!RECAPTCHA_SITE_KEY) {
      return true;
    }

    const token = await executeRecaptcha(action);
    const data = await verify({ variables: { token } });

    return data.data?.recaptchaVerify ?? false;
  };
};
